// @flow
import React from 'react';
import { Tab, TabPanel, TabPanels, Tabs } from '@reach/tabs';
import '@reach/tabs/styles.css';
import { SecondaryNavText } from '../../internal/internal-typography';
import { StyledTabList } from './tab_list';
import {
  TabProps,
  TabsProps,
  TabsKeyboardActivation,
  TabsOrientation,
} from '@reach/tabs';

const NavigationTab = (props: TabProps) => {
  const { children, ...restProps } = props;

  return (
    <Tab {...restProps}>
      <SecondaryNavText>{children}</SecondaryNavText>
    </Tab>
  );
};

const SideNavigationTabs = (props: TabsProps) => (
  <Tabs
    keyboardActivation={TabsKeyboardActivation.Manual}
    orientation={TabsOrientation.Vertical}
    {...props}
  />
);

export {
  SideNavigationTabs,
  StyledTabList as TabList,
  NavigationTab as Tab,
  TabPanels,
  TabPanel,
};
